import { useGetIdentity, type UserIdentity } from "ra-core";
import { SalesPerformanceDemo } from "./SalesPerformanceDemo";
import { SalesPerformanceProduction } from "./SalesPerformanceProduction";

export interface AdminUserIdentity extends UserIdentity {
  administrator?: boolean;
  role?: "superadmin" | "admin" | "sales";
}

/**
 * SalesPerformance Component
 *
 * Administrator-gated Sales Performance section:
 * - Strictly renders only when user is admin or superadmin (or identity?.administrator === true).
 * - Does not render either demo or production loaders before admin status is confirmed.
 * - Non-admin users, unresolved identities, and missing administrator fields fail closed.
 * - Does not issue performance or aggregate-view queries for non-admins.
 * - Branches to SalesPerformanceDemo in demo mode and SalesPerformanceProduction in production.
 */
export const SalesPerformance = () => {
  const { identity, isPending } = useGetIdentity();
  const adminIdentity = identity as AdminUserIdentity | undefined;

  const isAdmin =
    adminIdentity?.administrator === true ||
    adminIdentity?.role === "admin" ||
    adminIdentity?.role === "superadmin";

  if (isPending || !isAdmin) {
    return null;
  }

  return import.meta.env.VITE_IS_DEMO === "true" ? (
    <SalesPerformanceDemo />
  ) : (
    <SalesPerformanceProduction />
  );
};
